"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCertificate = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconCertificate = function IconCertificate(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.577 13.811V24L12 20.747 7.423 24V13.811l.012.002 1.534 2.945L12 15.248l3.031 1.51 1.534-2.945z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 14.174l-2.627 1.295-1.329-2.525-2.921-.429.476-2.79L3.5 7.735l2.099-1.99-.476-2.791 2.921-.429L9.373 0 12 1.295 14.627 0l1.329 2.525 2.921.429-.476 2.791 2.099 1.99-2.099 1.99.476 2.79-2.921.429-1.329 2.525z"
  }));
};
exports.IconCertificate = IconCertificate;